// @flow
import invariant from 'invariant';
import { compose, stringify, getIn } from 'utils/functional';

let config = null;

export const configValue = (...path: Array<string>): ?string =>
  getIn(config, path);

export const requiredConfig = (...path: Array<string>): string => {
  const v = getIn(config, path);
  invariant(v, `Config value ${path.toString()} is required`);
  return v;
};

export const configString: (...Array<string>) => string = compose(
  stringify,
  requiredConfig
);

export const setConfigOnce = (newConfig: Object) => {
  if (!config) {
    config = newConfig;
  }
};
